import { createFileRoute } from '@tanstack/react-router'

import { CustomerMatches } from '@/components/Customer/Matches'

export const Route = createFileRoute('/internal/customer-view/$userId/matches')(
  {
    component: CustomerMatches,
  },
)
